"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleEscrow__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  inputs: [],
  name: "CallerNotBeneficiary",
  type: "error"
}, {
  inputs: [],
  name: "CallerNotHolder",
  type: "error"
}, {
  inputs: [],
  name: "EmptyReceivingData",
  type: "error"
}, {
  inputs: [],
  name: "InactiveTitleEscrow",
  type: "error"
}, {
  inputs: [],
  name: "InvalidNominee",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "registry",
    type: "address"
  }],
  name: "InvalidRegistry",
  type: "error"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "InvalidTokenId",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    internalType: "address",
    name: "holder",
    type: "address"
  }],
  name: "InvalidTokenTransferToZeroAddressOwners",
  type: "error"
}, {
  inputs: [],
  name: "InvalidTransferToZeroAddress",
  type: "error"
}, {
  inputs: [],
  name: "NomineeAlreadyNominated",
  type: "error"
}, {
  inputs: [],
  name: "RecipientAlreadyHolder",
  type: "error"
}, {
  inputs: [],
  name: "RegistryContractPaused",
  type: "error"
}, {
  inputs: [],
  name: "TargetNomineeAlreadyBeneficiary",
  type: "error"
}, {
  inputs: [],
  name: "TitleEscrowNotHoldingToken",
  type: "error"
}, {
  inputs: [],
  name: "TokenNotSurrendered",
  type: "error"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromBeneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toBeneficiary",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "BeneficiaryTransfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromHolder",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toHolder",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "HolderTransfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "prevNominee",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "nominee",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Nomination",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Shred",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "surrenderer",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Surrender",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "holder",
    type: "address"
  }, {
    indexed: true,
    internalType: "bool",
    name: "isMinting",
    type: "bool"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "TokenReceived",
  type: "event"
}, {
  inputs: [],
  name: "active",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "beneficiary",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "holder",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_registry",
    type: "address"
  }, {
    internalType: "uint256",
    name: "_tokenId",
    type: "uint256"
  }],
  name: "initialize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "isHoldingToken",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_nominee",
    type: "address"
  }],
  name: "nominate",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "nominee",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "_tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "registry",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "shred",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "surrender",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "tokenId",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_nominee",
    type: "address"
  }],
  name: "transferBeneficiary",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newHolder",
    type: "address"
  }],
  name: "transferHolder",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_nominee",
    type: "address"
  }, {
    internalType: "address",
    name: "newHolder",
    type: "address"
  }],
  name: "transferOwners",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "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";

const isSuperArgs = xs => xs.length > 1;

class TitleEscrow__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.TitleEscrow__factory = TitleEscrow__factory;

_defineProperty(TitleEscrow__factory, "bytecode", _bytecode);

_defineProperty(TitleEscrow__factory, "abi", _abi);